import moment from "moment";

const dateStringAustraliatoDate = date => {
  //dd/mm/yyyy
  const regex = new RegExp(/([0-3][0-9])\/([0-1][0-9])\/[1-2]\d{3}$/g);
  if (!regex.test(date)) return undefined;

  // dd/mm/yyyy => [dd,mm,yyyy]
  const dateArr = date.split("/");
  //date should be in range of [01/01/1900, today]
  if (
    parseInt(dateArr[2], 10) < 1900 ||
    new Date(
      moment(`${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`).format("YYYY-MM-DD")
    ) > new Date(moment().format("YYYY-MM-DD"))
  )
    return undefined;

  if (moment(`${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`).isValid()) {
    return moment(
      moment(`${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`).format("YYYY-MM-DD")
    ).toDate();
  } else {
    return undefined;
  }
};

const dateToDateStringAustralia = date => {
  return moment(date).format("DD/MM/YYYY");
};

const compareDateWithToday = date => {
  const comparedDate = new Date(moment(date).format("YYYY-MM-DD"));
  const today = new Date(moment().format("YYYY-MM-DD"));
  return today >= comparedDate;
};

export {
  dateStringAustraliatoDate,
  dateToDateStringAustralia,
  compareDateWithToday
};



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/DatePicker/DatePickerHelper.js